import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import {
  FormControl,
  makeStyles,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core'
import { Check } from '@material-ui/icons'
import { answerAQuestion } from 'store/polling'
import { colors } from 'utils/colors'

const PollQuestionAttempt = ({ question }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { answeredBy, answers } = useSelector((state) => state.polling)

  const alreadyAnswered = answers?.find(
    (doc) =>
      doc?.answeredBy?.toLowerCase() === answeredBy?.toLowerCase() && doc.questionId === question.id
  )

  const handleChange = (event) => {
    const answerId = alreadyAnswered?.id ?? null
    dispatch(
      answerAQuestion(answerId, {
        optId: event.target.value,
        questionId: question?.id,
        pollId: question?.pollId,
        answeredBy: answeredBy
      })
    )
  }
  return (
    <FormControl key={question?.id} className={classes.card}>
      <Typography className={classes.questionTitle}>{question?.title}</Typography>
      <RadioGroup
        className={classes.radioGroup}
        name="controlled-radio-buttons-group"
        value={alreadyAnswered?.id ? alreadyAnswered?.optId : ''}
        onChange={handleChange}>
        {question?.options?.map((option) => {
          const isSelected = alreadyAnswered?.id && alreadyAnswered.optId === option.optId
          return (
            <Box className={classes.radioLabel} key={option.optId}>
              <FormControlLabel
                className={isSelected ? classes.checkedRadio : classes.selectedRadio}
                value={option.optId}
                control={<Radio className={classes.radio} />}
                label={
                  <Box className={classes.optionLabelContent}>
                    <span>{option.opt}</span>
                    {isSelected && <Check className={classes.checkIcon} />}
                  </Box>
                }
              />
            </Box>
          )
        })}
      </RadioGroup>
    </FormControl>
  )
}

export default PollQuestionAttempt

const useStyles = makeStyles((theme) => ({
  '@keyframes cardIn': {
    from: { opacity: 0, transform: 'translateY(12px)' },
    to: { opacity: 1, transform: 'translateY(0)' }
  },
  '@keyframes checkIn': {
    from: { opacity: 0, transform: 'scale(0.5)' },
    to: { opacity: 1, transform: 'scale(1)' }
  },
  card: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    border: '1px solid rgba(15, 23, 42, 0.06)',
    boxShadow: '0 20px 45px -20px rgba(15, 23, 42, 0.18), 0 2px 8px rgba(15, 23, 42, 0.04)',
    padding: '24px 20px',
    animation: '$cardIn 0.4s ease'
  },
  questionTitle: {
    fontWeight: '600',
    margin: '4px 0px 20px',
    fontSize: '20px',
    textAlign: 'center',
    color: '#0f172a',
    [theme.breakpoints.down('sm')]: {
      fontSize: '17px',
      textAlign: 'start'
    }
  },
  radio: {
    padding: '4px',
    '& .MuiIconButton-label': {
      display: 'none'
    }
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  radioLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  optionLabelContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '10px'
  },
  checkIcon: {
    fontSize: '20px',
    animation: '$checkIn 0.25s ease'
  },
  selectedRadio: {
    padding: '14px 18px',
    borderRadius: '14px',
    backgroundColor: '#f1f5f9',
    border: '1px solid rgba(15, 23, 42, 0.06)',
    width: '100%',
    minHeight: '56px',
    margin: '0px',
    transition: 'background-color 0.3s ease, border-color 0.3s ease, transform 0.15s ease',
    '&:active': {
      transform: 'scale(0.985)'
    },
    '& .MuiFormControlLabel-label': {
      width: '100%',
      color: '#1e293b'
    }
  },
  checkedRadio: {
    padding: '14px 18px',
    borderRadius: '14px',
    background: `linear-gradient(135deg, #0e93b3, ${colors.indigo})`,
    boxShadow: '0 10px 24px -10px rgba(21, 180, 219, 0.55)',
    color: '#FFFFFF',
    margin: '0px',
    width: '100%',
    minHeight: '56px',
    transition: 'background-color 0.3s ease, box-shadow 0.3s ease, transform 0.15s ease',
    '&:active': {
      transform: 'scale(0.985)'
    },
    '& .MuiFormControlLabel-label': {
      width: '100%',
      fontSize: '15px',
      fontWeight: '500',
      color: '#FFFFFF'
    }
  }
}))
